module.exports = __webpack_public_path__ + "static/Karo_2-0226a9ae4583898b51f8892d1da412e5.jpg";